document.addEventListener('DOMContentLoaded', function () {
  if (!window.Shopify || !window.Shopify.onItemAdded) return;

  const originalOnItemAdded = window.Shopify.onItemAdded;

  window.Shopify.onItemAdded = function () {
    try {
      window.location.href = '/cart';
    } catch (e) {}

    if (typeof originalOnItemAdded === 'function') {
      originalOnItemAdded.apply(this, arguments);
    }
  };
});
document.addEventListener('DOMContentLoaded', function () {
  // Sélecteurs possibles du bouton panier (on vise large)
  var cartButtons = document.querySelectorAll(
    '[data-drawer="#sf-cart-drawer"],' +   // bouton qui ouvre le tiroir
    '[data-cart-toggle],' +                // certains thèmes
    '.sf-cart-toggle,' +                   // Minimog / variantes
    '.header__icon--cart'                  // icône panier générique
  );

  cartButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/cart';
    });
  });
});

